<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-6">
                    <h3 class="text-uppercase">{{ $t('registrations.outdated') }}</h3>
                    <small class="text-muted">{{ $t('registrations.outdated-meaning', { age: dataConservation }) }}</small>
                    <p class="text-sm mt-3" v-if="empty">{{ $t('registrations.no-registration') }}</p>
                </div>
                <div class="col-6 text-right">
                    <base-button type="danger" size="sm" @click="deleteAll()">
                        <span class="btn-inner--icon"><i class="tim-icons icon-simple-remove"></i></span>
                        <span class="btn-inner--text">{{ $t('common.delete-all') }}</span>
                    </base-button>
                </div>
            </div>
        </div>

        <div class="pt-2" v-if="!empty">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    :data="ctrl.rows">

                <el-table-column :label="$t('common.cohort')">
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            {{ row.cohort.name }}
                        </h4>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.degree')">
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            {{ row.degree.name }}
                        </h4>
                        <badge type="warning" v-if="row.degree.status=='validation'">
                            {{ $t('status.validation') }}
                        </badge>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.creation')">
                    <template v-slot="{row}">
                        <small>
                            {{ creationDate(row) }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.owner')">
                    <template v-slot="{row}">
                        {{ owners[row.cohort.owner_id] }}
                    </template>
                </el-table-column>

                <el-table-column align="right" width="60" class-name="actions">
                    <template v-slot="{row}">
                        <a href="#" class="table-action text-danger" @click.prevent="ctrl.delete(row.id)">
                            <i class="tim-icons icon-simple-remove"></i>
                        </a>
                    </template>
                </el-table-column>

            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <portal to="modals">

            <confirm-modal v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('registrations.delete-confirm') }}</p>
            </confirm-modal>

            <confirm-modal v-model="ctrl.modals.confirmDeleteAll">
                <p>{{ $t('registrations.delete-all-confirm') }}</p>
            </confirm-modal>

        </portal>

    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import moment from 'moment'

    export default {

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/astral/api/front/registrations',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    modals: ['confirmDeleteAll'],
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['-created_at'],
                        relations: ['cohort', 'degree'],
                        include: ['owners'],
                        filters: { outdated: true },
                    }
                }),
                search: '',
                owners: {},
                moment: moment,
                editValidation: false
            }
        },

        computed: {

            dataConservation() {
                return this.$auth['config'].data_conservation
            },

            empty() {
                return this.ctrl.rows.length ==0 && !this.search
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.owners = Array.isArray(resp.data.included.owners) ? {} : resp.data.included.owners
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({ simpleSearch: val })
            }
        },

        methods: {

            creationDate(registration) {
                return this.moment(registration.created_at).format('YYYY/MM/DD')
            },

            deleteAll() {
                this.ctrl.modals.open('confirmDeleteAll').then(confirmResponse => {
                    if (confirmResponse.confirmed) {
                        this.$loader.show()
                        axios.delete(
                            '/astral/api/front/registrations',
                            { params: { filters: { outdated: true } }}
                        )
                        .then(response => {
                            this.ctrl.list()
                            this.$loader.hide()
                        }).catch(error => {
                            this.ctrl.list()
                            this.$loader.hide()
                            //this.$auth.handleErrorVm(error, this)
                        })
                    }
                })
            },

            mapData(registration) {
                return {
                    id: registration ? registration.id : null,
                    status: registration ? registration.status : null,
                    cohort_id: registration ? registration.cohort_id : null,
                    degree_id: registration ? registration.degree_id : null,
                    cohort: registration ? registration.cohort : null,
                    degree: registration ? registration.degree : null,
                    track: registration ? (registration.track == 1) : !this.editValidation,
                    created_at: registration ? registration.created_at : null,
                }
            },

            unmapData(data) {
                return data
            }
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.actions,
    .card >>> td.actions {
        padding-left: 0;
        padding-right: 1.5rem;
    }

</style>
